import enImages from 'src/components/laws/interactive-picture/field-of-play/images/en'
import deImages from 'src/components/laws/interactive-picture/field-of-play/images/de'
import esImages from 'src/components/laws/interactive-picture/field-of-play/images/es'
import frImages from 'src/components/laws/interactive-picture/field-of-play/images/fr'
import ptBRImages from 'src/components/laws/interactive-picture/field-of-play/images/pt-BR'

const images = [...enImages, ...deImages, ...esImages, ...frImages, ...ptBRImages]

export default images
